export enum LOGO {
  CLIENT = 'CLIENT',
  COMPANY = 'COMPANY',
  CUSTOMER = 'CUSTOMER'
}
